import React, { useState, useContext } from 'react';
import styled from 'styled-components';
import {
  Grid,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from '@material-ui/core';
import { Checkbox } from '../ui/forms/Checkbox';
import { Button } from '../ui/forms/Button';
import { UserContext } from '../../contexts/UserContext';

// SITE TYPES
// 0: SmartRider
// 1: ID Cards
// 2: MyWayDriver
// 3: SmartRider (Driver)
// 4: MonDemoQLD
// 5: MyWay
// 6: DepOfCommunities

const SiteForm = ({ site, close, refresh }) => {
  const { updateSite, createSite } = useContext(UserContext);

  const [loading, setLoading] = useState(false);
  const [currentSite, setCurrentSite] = useState(
    site ?? {
      siteCode: '',
      siteType: 0,
      name: '',
      street: '',
      suburb: '',
      state: 'WA',
      postcode: '',
      telephone: '',
      orientation: 0,
      showPhoto: true,
      photoRequired: false,
      wondeAllowed: false,
      compassAllowed: false,
      showAddress: false,
      deleteAll: false,
      showCampaigns: true,
    }
  );
  const {
    siteCode,
    siteType,
    name,
    street,
    suburb,
    state,
    postcode,
    telephone,
    orientation,
    showPhoto,
    photoRequired,
    wondeAllowed,
    compassAllowed,
    showAddress,
    deleteAll,
    showCampaigns,
  } = currentSite;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!site) {
      await createSite(currentSite);
    } else {
      await updateSite(siteCode, currentSite);
    }
    refresh();
    close();

    setLoading(false);
  };

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    if (type === 'checkbox') {
      setCurrentSite((s) => ({ ...s, [name]: !s[name] }));
    } else {
      setCurrentSite((s) => ({ ...s, [name]: value }));
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={2} style={{ marginBottom: '2rem' }}>
        <Grid item xs={12} md={6}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                name='siteCode'
                value={siteCode}
                disabled={!!site}
                onChange={handleChange}
                label={!site ? 'Site Code' : null}
                required={!site}
              />
            </Grid>
            <Grid item xs={6}>
              <FormControl>
                <InputLabel id='siteType'>Site Type</InputLabel>
                <Select
                  name='siteType'
                  value={siteType}
                  onChange={handleChange}
                  label='Site Type'
                  labelId='siteType'
                >
                  <MenuItem value={0}>SmartRider</MenuItem>
                  <MenuItem value={3}>SmartRider (Driver)</MenuItem>
                  <MenuItem value={1}>ID Cards</MenuItem>
                  <MenuItem value={2}>MyWay (Driver)</MenuItem>
                  <MenuItem value={4}>MonDemoQLD</MenuItem>
                  <MenuItem value={5}>MyWay</MenuItem>
                  <MenuItem value={6}>Department of Communities</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <TextField
            name='name'
            value={name}
            onChange={handleChange}
            label='Site Name'
            required
          />

          <TextField
            type='tel'
            name='telephone'
            value={telephone}
            onChange={handleChange}
            label='Telephone'
          />

          <FormControl>
            <InputLabel id='orientation'>Card Orientation</InputLabel>
            <Select
              name='orientation'
              value={orientation}
              options={[
                { id: 0, value: 0, label: 'Landscape' },
                { id: 1, value: 1, label: 'Portrait' },
              ]}
              onChange={handleChange}
              label='Card Orientation'
              labelId='orientation'
              required
            >
              <MenuItem value={0}>Landscape</MenuItem>
              <MenuItem value={1}>Portrait</MenuItem>
            </Select>
          </FormControl>

          <Checkbox
            name='showPhoto'
            onChange={handleChange}
            checked={showPhoto}
            label='Enable Photos'
          />
          <Checkbox
            name='photoRequired'
            onChange={handleChange}
            checked={photoRequired}
            label='Require Photos'
          />
          <Checkbox
            name='wondeAllowed'
            onChange={handleChange}
            checked={wondeAllowed}
            label='Wonde Allowed'
          />
          <Checkbox
            name='compassAllowed'
            onChange={handleChange}
            checked={compassAllowed}
            label='Compass Allowed'
          />
          <Checkbox
            name='showAddress'
            onChange={handleChange}
            checked={showAddress}
            label='Show Address'
          />
          <Checkbox
            name='deleteAll'
            onChange={handleChange}
            checked={deleteAll}
            label='Delete All'
          />
          <Checkbox
            name='showCampaigns'
            onChange={handleChange}
            checked={showCampaigns}
            label='Show Campaign'
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            name='street'
            value={street}
            onChange={handleChange}
            label='Street Address'
            required
          />
          <TextField
            name='suburb'
            value={suburb}
            onChange={handleChange}
            label='Suburb'
            required
          />

          <Grid container spacing={2}>
            <Grid item xs={6}>
              <FormControl>
                <InputLabel id='state'>State</InputLabel>
                <Select
                  name='state'
                  value={state}
                  onChange={handleChange}
                  label='State'
                  labelId='state'
                >
                  <MenuItem value='WA'>WA</MenuItem>
                  <MenuItem value='NSW'>NSW</MenuItem>
                  <MenuItem value='ACT'>ACT</MenuItem>
                  <MenuItem value='VIC'>VIC</MenuItem>
                  <MenuItem value='SA'>SA</MenuItem>
                  <MenuItem value='NT'>NT</MenuItem>
                  <MenuItem value='QLD'>QLD</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <TextField
                name='postcode'
                value={postcode}
                onChange={handleChange}
                label='Postcode'
                required
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Actions>
        <Button type='submit' disabled={loading} colour='success'>
          {!site ? 'Create' : 'Update'} Site
        </Button>
      </Actions>
    </form>
  );
};

const Actions = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  padding-bottom: 1rem;
`;

export default SiteForm;
